import { render, staticRenderFns } from "./PanelRekamMedis.vue?vue&type=template&id=24d1bc14&scoped=true"
import script from "./PanelRekamMedis.vue?vue&type=script&lang=js"
export * from "./PanelRekamMedis.vue?vue&type=script&lang=js"
import style0 from "./PanelRekamMedis.vue?vue&type=style&index=0&id=24d1bc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1bc14",
  null
  
)

export default component.exports